(() => {
  'use strict';

  const root = document.documentElement;
  if (root.hasAttribute('data-cfm-cart-modal-init')) {
    return;
  }
  root.setAttribute('data-cfm-cart-modal-init', 'true');

  const state = {
    lastFocusedElement: null,
    cart: null
  };

  const elements = {
    modal: document.querySelector('[data-cart-modal]'),
    panel: document.querySelector('.cfm-cart-modal__panel'),
    loading: document.querySelector('[data-cart-loading]'),
    error: document.querySelector('[data-cart-error]'),
    items: document.querySelector('[data-cart-items]'),
    empty: document.querySelector('[data-cart-empty]'),
    total: document.querySelector('[data-cart-total]')
  };

  if (!elements.modal || !elements.panel || !elements.items || !elements.total) {
    return;
  }

  const mobileMediaQuery = window.matchMedia('(max-width: 767px)');
  const isMobileViewport = () => mobileMediaQuery.matches;

  const escapeHtml = (value) => {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  const formatMoney = (amount, currency) => {
    const safeAmount = Number(amount) || 0;
    const safeCurrency = currency || 'JPY';
    const normalizedAmount = safeAmount / 100;

    if (safeCurrency === 'JPY') {
      return `${Math.round(normalizedAmount).toLocaleString('ja-JP')}円`;
    }

    return new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: safeCurrency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(normalizedAmount);
  };

  const setLoading = (isLoading) => {
    if (!elements.loading) {
      return;
    }

    elements.loading.hidden = !isLoading;
  };

  const setError = (message) => {
    if (!elements.error) {
      return;
    }

    const hasMessage = Boolean(message);
    elements.error.hidden = !hasMessage;
    elements.error.textContent = hasMessage ? message : '';
  };

  const updateCount = (count) => {
    const safeCount = Number(count) || 0;
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = String(safeCount);
      node.hidden = safeCount === 0;
    });
  };

  const getCurrentDisplayedCount = () => {
    const countNode = document.querySelector('[data-cart-count]');
    if (!countNode) {
      return 0;
    }

    return Number(countNode.textContent) || 0;
  };

  const getVariantIdFromTrigger = (trigger) => {
    const variantIdFromData = Number(trigger.getAttribute('data-variant-id'));
    if (variantIdFromData) {
      return variantIdFromData;
    }

    const form = trigger.closest('form[action*="/cart/add"]');
    if (!form) {
      return 0;
    }

    const idField = form.querySelector('input[name="id"], select[name="id"]');
    return Number(idField && idField.value);
  };

  const getQuantityFromTrigger = (trigger) => {
    const quantityFromData = Number(trigger.getAttribute('data-quantity'));
    if (Number.isFinite(quantityFromData) && quantityFromData > 0) {
      return Math.max(1, quantityFromData);
    }

    const form = trigger.closest('form[action*="/cart/add"]');
    if (form) {
      const quantityField = form.querySelector('input[name="quantity"]');
      const quantityFromForm = Number(quantityField && quantityField.value);
      if (Number.isFinite(quantityFromForm) && quantityFromForm > 0) {
        return Math.max(1, quantityFromForm);
      }
    }

    return 1;
  };

  const renderItems = (cart) => {
    const itemList = Array.isArray(cart.items) ? cart.items : [];

    if (itemList.length === 0) {
      elements.items.innerHTML = '';
      if (elements.empty) {
        elements.empty.hidden = false;
      }
      return;
    }

    if (elements.empty) {
      elements.empty.hidden = true;
    }

    const html = itemList
      .map((item) => {
        const title = escapeHtml(item.product_title || item.title || '');
        const image = item.image
          ? `<img class="cfm-cart-modal__thumb" src="${escapeHtml(item.image)}" alt="${title}" loading="lazy">`
          : '<div class="cfm-cart-modal__thumb" aria-hidden="true"></div>';
        const quantity = Number(item.quantity) || 0;
        const linePrice = formatMoney(item.final_line_price, cart.currency);
        const itemKey = escapeHtml(item.key || '');

        let setLink = '';
        if (window.plBsGetProduct) {
          const pd = window.plBsGetProduct(item.product_id);
          if (pd && !pd.isSet && pd.related && pd.related[0] && pd.related[0].isSet) {
            setLink = `<button type="button" class="cfm-setlink cfm-setlink--item" data-cart-set-open="${item.product_id}">${title}が入ったセットはこちら →</button>`;
          }
        }

        return `
          ${setLink ? `<li class="cfm-cart-modal__linkrow">${setLink}</li>` : ''}
          <li class="cfm-cart-modal__item">
            <div class="cfm-cart-modal__tap" data-cart-item-pid="${escapeHtml(item.product_id)}" data-cart-item-url="${escapeHtml(item.url || '')}" role="button" tabindex="0" aria-label="${title}の詳細を見る">
              ${image}
              <div class="cfm-cart-modal__info">
                <p class="cfm-cart-modal__name">${title}</p>
                <p class="cfm-cart-modal__meta">小計: ${linePrice}</p>
              </div>
            </div>
            <div class="cfm-cart-modal__qty">
              <button type="button" class="cfm-cart-modal__qbtn" data-cart-qty-change="-1" data-cart-key="${itemKey}" ${quantity <= 1 ? 'disabled' : ''} aria-label="1個減らす">−</button>
              <span class="cfm-cart-modal__qnum" aria-live="polite">${quantity}</span>
              <button type="button" class="cfm-cart-modal__qbtn" data-cart-qty-change="1" data-cart-key="${itemKey}" aria-label="1個増やす">＋</button>
            </div>
            <button type="button" class="cfm-cart-modal__remove" data-cart-remove="${itemKey}">削除</button>
          </li>
        `;
      })
      .join('');

    elements.items.innerHTML = `<ul class="cfm-cart-modal__list">${html}</ul>`;
  };

  const renderUpsell = (cart) => {
    const el = document.querySelector('[data-cart-upsell]');
    if (!el) {
      return;
    }
    let html = '';
    const FREE = 250000; // ¥2,500（cent）
    if (cart.item_count > 0 && cart.total_price < FREE) {
      const remain = Math.round((FREE - cart.total_price) / 100);
      const pct = Math.min(100, Math.round((cart.total_price / FREE) * 100));
      html += `<div class="cfm-ship"><span class="cfm-ship__txt">あと <b>¥${remain.toLocaleString('ja-JP')}</b> で送料無料</span><span class="cfm-ship__bar"><i style="width:${pct}%"></i></span></div>`;
    } else if (cart.item_count > 0) {
      html += '<div class="cfm-ship cfm-ship--ok">送料無料でお届けします ✓</div>';
    }
    // セット提案リンクは各商品カードの真上に出す（renderItems側）。ここは送料ゲージのみ
    el.innerHTML = html;
    el.hidden = !html;
  };

  const renderCart = (cart) => {
    state.cart = cart;
    updateCount(cart.item_count);
    elements.total.textContent = formatMoney(cart.total_price, cart.currency);
    renderUpsell(cart);
    renderItems(cart);
    document.dispatchEvent(new CustomEvent('cfm:cart-updated', { detail: { cart } }));
  };

  const fetchCart = async () => {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('カート情報の取得に失敗しました。');
    }

    return response.json();
  };

  const refreshCart = async () => {
    setError('');
    setLoading(true);

    try {
      const cart = await fetchCart();
      renderCart(cart);
      return cart;
    } catch (error) {
      setError(error.message || 'カート情報の取得に失敗しました。');
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const isModalOpen = () => !elements.modal.hidden;

  const openModal = () => {
    state.lastFocusedElement = document.activeElement;
    elements.modal.hidden = false;
    elements.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cfm-modal-open');
    elements.panel.focus();
  };

  const closeModal = () => {
    if (!isModalOpen()) {
      return;
    }

    elements.modal.hidden = true;
    elements.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cfm-modal-open');

    if (state.lastFocusedElement && typeof state.lastFocusedElement.focus === 'function') {
      state.lastFocusedElement.focus();
      return;
    }

    const fallback = document.querySelector('[data-cart-open]');
    if (fallback) {
      fallback.focus();
    }
  };

  const addToCart = async (variantId, quantity) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity
      })
    });

    if (!response.ok) {
      const errorJson = await response.json().catch(() => ({}));
      const description = errorJson.description || '商品追加に失敗しました。';
      throw new Error(description);
    }

    return response.json();
  };

  const changeQuantity = async (itemKey, quantity) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: itemKey, quantity })
    });

    if (!response.ok) {
      throw new Error('数量の変更に失敗しました。');
    }

    return response.json();
  };

  // ---- 数量の楽観的更新（タップ即反映→裏で同期。連打は350msまとめて送信） ----
  const pendingQty = new Map();

  const applyOptimisticQty = (key, qty) => {
    if (!state.cart || !Array.isArray(state.cart.items)) {
      return;
    }
    const item = state.cart.items.find((it) => it.key === key);
    if (!item) {
      return;
    }
    item.quantity = qty;

    const anyBtn = elements.items.querySelector(`[data-cart-key="${CSS.escape(key)}"]`);
    const li = anyBtn && anyBtn.closest('.cfm-cart-modal__item');
    if (li) {
      const num = li.querySelector('.cfm-cart-modal__qnum');
      if (num) num.textContent = String(qty);
      const minus = li.querySelector('[data-cart-qty-change="-1"]');
      if (minus) minus.disabled = qty <= 1;
      const meta = li.querySelector('.cfm-cart-modal__meta');
      if (meta) meta.textContent = `小計: ${formatMoney((item.final_price || item.price) * qty, state.cart.currency)}`;
    }

    const totalPrice = state.cart.items.reduce((s, it) => s + (it.final_price || it.price) * it.quantity, 0);
    const totalCount = state.cart.items.reduce((s, it) => s + it.quantity, 0);
    elements.total.textContent = formatMoney(totalPrice, state.cart.currency);
    updateCount(totalCount);
  };

  const scheduleQtySync = (key) => {
    const prev = pendingQty.get(key);
    if (prev && prev.timer) {
      clearTimeout(prev.timer);
    }
    const timer = setTimeout(async () => {
      pendingQty.delete(key);
      const item = state.cart && state.cart.items ? state.cart.items.find((it) => it.key === key) : null;
      if (!item) {
        return;
      }
      try {
        const cart = await changeQuantity(key, item.quantity);
        // 連打の追送が残っていなければサーバー値で確定描画
        if (pendingQty.size === 0) {
          renderCart(cart);
        }
      } catch (error) {
        setError(error.message || '数量の変更に失敗しました。');
        refreshCart().catch(() => {});
      }
    }, 350);
    pendingQty.set(key, { timer });
  };

  const removeFromCart = async (itemKey) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    });

    if (!response.ok) {
      throw new Error('商品の削除に失敗しました。');
    }

    return response.json();
  };

  document.addEventListener('click', async (event) => {
    if (!isMobileViewport()) {
      return;
    }

    const openTrigger = event.target.closest('[data-cart-open]');
    if (openTrigger) {
      event.preventDefault();
      openModal(); // 先に開く（体感を速く）。中身は裏で更新
      refreshCart().catch(() => {
        // Error message is already shown in modal.
      });
      return;
    }

    const closeTrigger = event.target.closest('[data-cart-close], [data-cart-close-btn]');
    if (closeTrigger) {
      event.preventDefault();
      closeModal();
      return;
    }

    // 数量の＋/−（楽観的更新：即反映→裏で同期）
    const qtyTrigger = event.target.closest('[data-cart-qty-change]');
    if (qtyTrigger) {
      event.preventDefault();
      const key = qtyTrigger.getAttribute('data-cart-key');
      const delta = Number(qtyTrigger.getAttribute('data-cart-qty-change')) || 0;
      const item = state.cart && state.cart.items ? state.cart.items.find((it) => it.key === key) : null;
      if (!key || !item) {
        return;
      }
      const newQty = Math.max(1, (Number(item.quantity) || 1) + delta);
      if (newQty === item.quantity) {
        return;
      }
      setError('');
      applyOptimisticQty(key, newQty);
      scheduleQtySync(key);
      return;
    }

    // セット提案タップ → その商品が入ったセット一覧を開く
    const setOpen = event.target.closest('[data-cart-set-open]');
    if (setOpen) {
      event.preventDefault();
      closeModal();
      const pid = setOpen.getAttribute('data-cart-set-open');
      if (window.plBsOpenSetList) {
        window.plBsOpenSetList(pid);
      } else if (window.plBsOpenById) {
        window.plBsOpenById(pid);
      }
      return;
    }

    // 商品タップ → ボトムシートで詳細（シートが無いページでは商品ページへ）
    const itemTap = event.target.closest('[data-cart-item-pid]');
    if (itemTap && isModalOpen()) {
      event.preventDefault();
      const pid = itemTap.getAttribute('data-cart-item-pid');
      if (window.plBsOpenById) {
        closeModal();
        if (window.plBsOpenById(pid, { fromCart: true })) {
          return;
        }
      }
      const url = itemTap.getAttribute('data-cart-item-url');
      if (url) {
        window.location.href = url;
      }
      return;
    }

    const removeTrigger = event.target.closest('[data-cart-remove]');
    if (removeTrigger) {
      event.preventDefault();
      const itemKey = removeTrigger.getAttribute('data-cart-remove');
      if (!itemKey) {
        return;
      }

      removeTrigger.disabled = true;
      setError('');

      try {
        const cart = await removeFromCart(itemKey);
        renderCart(cart);
      } catch (error) {
        setError(error.message || '商品の削除に失敗しました。');
      } finally {
        removeTrigger.disabled = false;
      }
      return;
    }

    const addTrigger = event.target.closest(
      '[data-add-to-cart], .add-cart-btn-js, form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [name="add"]'
    );
    if (!addTrigger) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    const variantId = getVariantIdFromTrigger(addTrigger);
    if (!variantId) {
      setError('バリアントIDが見つかりません。');
      return;
    }

    const quantity = getQuantityFromTrigger(addTrigger);
    const previousCount = Number(state.cart && state.cart.item_count);
    const baseCount = Number.isFinite(previousCount) ? previousCount : getCurrentDisplayedCount();
    const optimisticCount = baseCount + quantity;

    addTrigger.setAttribute('aria-busy', 'true');
    addTrigger.style.pointerEvents = 'none';
    setError('');
    updateCount(optimisticCount);

    try {
      await addToCart(variantId, quantity);
    } catch (error) {
      updateCount(baseCount);
      setError(error.message || '商品追加に失敗しました。');
      return;
    }

    let cart = null;
    try {
      cart = await refreshCart();
    } catch (error) {
      setError('商品は追加されましたが、カート情報の更新に失敗しました。');
    }

    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      }
    } finally {
      addTrigger.removeAttribute('aria-busy');
      addTrigger.style.pointerEvents = '';
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (!isMobileViewport()) {
      return;
    }

    if (event.key === 'Escape' && isModalOpen()) {
      closeModal();
    }
  });

  const handleViewportChange = () => {
    if (!isMobileViewport()) {
      closeModal();
      setError('');
      setLoading(false);
      return;
    }

    refreshCart().catch(() => {
      // Initial load error is displayed only when modal is opened.
    });
  };

  if (typeof mobileMediaQuery.addEventListener === 'function') {
    mobileMediaQuery.addEventListener('change', handleViewportChange);
  } else if (typeof mobileMediaQuery.addListener === 'function') {
    mobileMediaQuery.addListener(handleViewportChange);
  }

  handleViewportChange();
})();
